<template>
    <div class="row gy-2">
        <div class="col-12">
            <h5 class="mb-3">List of Your Union Dues</h5>
            <div class="row mb-3 gy-2 justify-content-between">
                <div class="col-md-6 col-lg-5 d-flex">
                    <div class="input-group w-auto">
                        <b-form-select style="max-width:100px;" class="form-select" v-model="itemsPerPage"
                            :options="pageOptions"></b-form-select>
                    </div>
                </div>
                <div class="col-md-5">
                    <div class="input-group mb-0">
                        <input v-model="searchQuery" @input="updateSearchQuery" type="search" class="form-control"
                            placeholder="Search here..." aria-label="Search here..."
                            aria-describedby="button-search_TB">
                        <button @click="fetchItems()" class="btn btn-primary" type="button" id="button-search_TB"><span
                                class="ri ri-search-line"></span></button>
                    </div>
                </div>
            </div>
            <div class="mb-3">
                <p class="mb-0">Showing {{ paginationInfo }} results</p>
            </div>
            <div v-if="isLoading" class="row g-3 g-lg-4">
                <div v-for="(data, dIndex) in 3" :key="dIndex" class="col-sm-6 col-xl-4">
                    <div class="card h-100 mb-0 card-animate overflow-hidden" style="min-height: 200px;">
                        <CommonSkeletonLoader v-if="isLoading" />
                    </div>
                </div>
            </div>
            <div v-else class="row g-3 g-lg-4">
                <div v-for="(data, dIndex) in pageData.data" :key="dIndex" class="col-sm-6 col-xl-4">
                    <div class="card h-100">
                        <div class="card-body p-3 d-flex flex-column justify-content-between">
                            <div>
                                <h5 class="mb-4">{{ data.union_name }}</h5>
                                <p class="mb-1">Status: <strong><span v-html="statusBadge(data.union_status)"></span></strong></p>
                                <p class="mb-1">Monthly Deduction: 
                                    <strong v-if="data.union_amount_type == 'percentage'" class="text-capitalize" v-b-tooltip.hover
                                        :title="`${data.union_amount}% of ₦${$filters.number_format(data.basic_salary, 2)}`">
                                        ₦{{ $filters.number_format(data.evaluated_amount, 2) }} </strong>
                                    <strong v-else class="text-capitalize">₦{{ $filters.number_format(data.union_amount, 2) }}
                                    </strong>
                                </p>
                            </div>
                            <div class="d-grid">
                                <button class="btn btn-sm btn-primary" type="button" @click.prevent="viewItem(data)">View payments</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="my-4">
                <b-pagination v-model="currentPage" :limit="pageLimit" class="pagination-rounded"
                    :total-rows="pageData.total" :per-page="itemsPerPage"></b-pagination>
            </div>

            <b-modal hide-footer v-model="employeeUnionShow.modal" body-class="shadow-lg" title="Union dues payments">
                <union-dues-payments v-if="employeeUnionShow.modal" @closeMe="initializeAll();"
                 :employeeUnion="employeeUnionShow.item"  />
            </b-modal>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import { commonSortingMixin } from '@shared/mixins/commonSortingMixin';
import { commonPaginationMixin } from '@shared/mixins/commonPaginationMixin';
import UnionDuesPayments from './UnionDuesPayments.vue';

export default {
    name: "union-dues-list",
    mixins: [
        commonSortingMixin,
        commonPaginationMixin,
    ],
    components:{
        UnionDuesPayments
    },
    data() {
        return {
            isLoading: false,
            employeeUnionShow: { modal: false, item: null },

            statusOptions: [
                { value: 'active', label: 'Active' },
                { value: 'completed', label: 'Completed' },
                { value: 'pending', label: 'Pending' },
                { value: 'paused', label: 'Paused' },
                { value: 'stopped', label: 'Stopped' },
                { value: 'complete_duration', label: 'Complete duration' },
                { value: 'cancelled', label: 'Cancelled' }
            ],
            searchQuery: "",
            sortBy: {
                sort_column: "created_at",
                sort_direction: "desc"
            },
            pageData: {
                data: []
            },
        }
    },
    methods: {
        navigateTo(item) {
        },
        updateSearchQuery: _.debounce(function (string) {
            this.fetchItems()
        }, 2000),
        fetchItems(page, per_page = null) {
            let payload = {
                page: page || 1, per_page: per_page || this.itemsPerPage,
                ...this.sortBy
            }
            if (this.searchQuery) { payload.search = this.searchQuery }

            this.isLoading = true
            this.$http.get(`/union-dues?${new URLSearchParams(payload).toString()}`)
                .then((response) => {
                    this.isLoading = false
                    if (response.data.success) {
                        this.pageData = response.data.data
                        this.initializeAll();
                    }
                })
        },
        viewItem(item) {
            if(item){
                this.employeeUnionShow.item = {...item}
                this.employeeUnionShow.modal = true
            }
        },
        initializeAll() {
            this.employeeUnionShow = { modal: false, item:null };
        },
    },
    created() {
        this.fetchItems()
    },
}

</script>
